import Component from '../inherited/Component';

export default class Hotspots extends Component {
  constructor(elem, theme, options, ctx) {
    super(elem, theme, options, ctx);
    this._hotspots = this._elem.querySelectorAll('[data-product-hotspot]')
  }

  mount() {

    for(let hotspot of this._hotspots) {
        hotspot.addEventListener('click', (e) => {
            this.updateHotspot(hotspot.dataset.productHotspot)

            this._slider = this._theme.getComponentByElem(this._elem.querySelector('[data-keen-slider]'))
            this._slider.component.goToSlide((hotspot.dataset.productHotspot - 1))
        });
    }

    this._ctx.on('keen-slider:change', data => {
        if(!data.namespace == this._elem) return
        let activeSlide = this._elem.querySelector('[data-keen-slider] .keen-slider__slide.active')
        let activeSlideIndex = ([...activeSlide.parentElement.children].indexOf(activeSlide) + 1)
        this.updateHotspot(activeSlideIndex)
    })
  }

  updateHotspot(activeSpot) {
    for(let hotspot of this._hotspots) {
        if(hotspot.dataset.productHotspot != activeSpot) {
            hotspot.classList.remove('active')
        } else {
            hotspot.classList.add('active')
        }
    }
  }
}
